import { render } from "./BuyerTwoColumnPage.vue?vue&type=template&id=1df8f8f1&scoped=true"
import script from "./BuyerTwoColumnPage.vue?vue&type=script&lang=js"
export * from "./BuyerTwoColumnPage.vue?vue&type=script&lang=js"

import "./BuyerTwoColumnPage.vue?vue&type=style&index=0&id=1df8f8f1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df8f8f1"]])

export default __exports__